import React from 'react';
import { PRODUCT_NAME } from './checkout';
export function Footer() {
  return <footer className="bg-forest-dark py-8 border-t border-gold/30 text-center px-4" data-id="element-138" data-mp="3gezcj1s77n03">
      <div className="max-w-4xl mx-auto" data-id="element-139" data-mp="3gh3ng3oilm9v">
        <p className="text-ivory/70 text-sm" data-id="element-140" data-mp="32ovxaurqktk5">
          © {new Date().getFullYear()} {PRODUCT_NAME} — All rights reserved.
        </p>
      </div>
    </footer>;
}